import MeasuresPage from "./MeasuresPage";

export default MeasuresPage;
